import {
  Box,
  Flex,
  Avatar,
  Button,
  Menu,
  MenuButton,
  useColorModeValue,
  Stack,
  useColorMode,
  Image,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import Logo from "../Img/mainlogo1.png";
import Logo2 from "../Img/logowight.png";
export default function Nav() {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <>
      <Box px={4} backgroundColor={'#000'}>
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <Box marginTop={['3vh','7vh']}>
            <Image width={["40vw",null,"15vw"]} src={useColorModeValue(Logo2,Logo)} alt="LOGO" />
          </Box>

          <Flex alignItems={"center"}>
            <Stack direction={"row"} spacing={7}>
            

              {/* For users */}
              {/* <Menu>
                  <MenuButton
                    as={Button}
                    rounded={'full'}
                    variant={'link'}
                    cursor={'pointer'}
                    minW={0}
                  >
                    <Avatar size={'sm'} src={MainLogo} />
                  </MenuButton>
                </Menu> */}
            </Stack>
          </Flex>
        </Flex>
      </Box>
    </>
  );
}
